import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

const LoginRoute = ({ component, render, exact = false, path, authenticated }) => (
   <Route
      exact={exact}
      path={path}
      render={props =>
         authenticated ? (
            render ? render(props) : React.createElement(component, props)
         ) : (
            <Redirect
               to={{
                  pathname: '/login',
                  state: { from: props.location },
               }}
            />
         )
      }
   />
);

const { object, bool, string, func } = PropTypes;

LoginRoute.propTypes = {
   component: func,
   render: func,
   exact: bool,
   path: string.isRequired,
   authenticated: bool.isRequired,
   location: object,
};

export default LoginRoute;
